// Palette unified with the RKH site brand (DESIGN.md, synced copy in
// docs/DESIGN.md) — slides sit on the brand's black anchor with warm bone
// text, never pure white.
//
// Values only, no annotations: each export infers its own literal type, which
// is strictly better than the `: string` the deleted tokens.d.ts mirror
// declared. That mirror existed because the studio server imports this module
// directly and a plain .js import fails TS7016; converting the module removes
// the reason for it, and with it the "HAND-SYNCED, update both together"
// footgun of adding an export in one file and not the other.
export const BG = '#000000';
export const BG_ELEV = '#1e1e1e';
export const BG_INK = '#141419';
export const BG_CARD = '#0d0d0d'; // near-black card panel — reads as a surface without breaking the black anchor
export const FG = '#f6f3ec'; // bone — brand text on dark
export const FG_2 = '#f6f3ecf2'; // 95% — body copy
export const FG_3 = '#f6f3eceb'; // 92% — captions, secondary
export const FG_4 = '#f6f3ece6'; // 90% — sources, small print
export const FG_5 = '#f6f3ece0'; // 88% — slide numbers, dividers (floor)
export const LINE = '#f6f3ec3a';
export const LINE_2 = '#f6f3ec66';
// Five brand accents (DESIGN.md bright cuts). Legacy export names kept so
// existing deck code keeps compiling: GREEN and YELLOW both resolve to lime,
// PURPLE to violet. New work should read them as orange/cyan/lime/pink/violet.
export const ORANGE = '#FF5A1F';
export const CYAN = '#33D1CF';
export const YELLOW = '#C8F24E'; // lime (legacy name)
export const PURPLE = '#9B7BFF'; // violet (legacy name)
export const PINK = '#FF4D9D';
export const GREEN = '#C8F24E'; // lime (legacy name)
// RENAME POINT — the four extended accents. These names are referenced only
// here, in accents.js and in ink.js; everything else consumes those two lists,
// so renaming one is a three-file change. LEMON is a TRUE yellow, distinct from
// the lime that YELLOW/GREEN both alias.
export const LEMON = '#FAF553'; // bright yellow
export const BLOSSOM = '#FFC8FF'; // pale pink
export const BLUSH = '#FFE2DE'; // pale blush
export const SCARLET = '#EC002A'; // strong warm red
// Semantic red for negative deltas / cons — NOT a slide accent (never appears
// in the accent rotation, never in accents.js); the single home for what was a
// repeated '#ff4444'. The red ACCENT is SCARLET (#EC002A) above — these two are
// deliberately not near-neighbours by name, so a slide never reaches for the
// wrong one.
export const RED_NEG = '#ff4444';
export const SANS = '"Neuzeit Grotesk", "Helvetica Neue", Helvetica, Arial, sans-serif';
export const MONO = 'ui-monospace, "SF Mono", Menlo, Consolas, monospace';
